import * as URL from "../../helpers/Constants";
import axios from "axios";

export default class PMSCustomerServices {

    static getAllCustomersByPharmacyId(id, params) {
        return axios.get(`${URL.PMS_GET_ALL_CUSTOMER_BY_PHARMACY_ID}/${id}`, {
            ...PMSCustomerServices.getAuthHeader(),
            params
        })
    }

    static getAllLiteCustomersByPharmacyId(page, size, id) {
        return axios.get(`${URL.PMS_GET_ALL_LITE_CUSTOMER_BY_PHARMACY_ID}/${id}`, {
            ...PMSCustomerServices.getAuthHeader(),
            params: {page, size}
        })
    }

    static getCustomerByPharmacyIdById(pharmacyId, id) {
        return axios.get(`${URL.PMS_GET_CUSTOMER_BY_PHARMACY_ID_BY_ID}/${pharmacyId}/${id}`, PMSCustomerServices.getAuthHeader())
    }

    static getCustomerByPharmacyIdByLocalId(pharmacyId, localId) {
        return axios.get(`${URL.PMS_GET_CUSTOMER_BY_PHARMACY_ID_BY_LOCAL_ID}/${pharmacyId}/${localId}`, PMSCustomerServices.getAuthHeader())
    }

    static createCustomerByPharmacyId(id, data) {
        return axios.post(`${URL.PMS_CREATE_CUSTOMER_BY_PHARMACY_ID}/${id}`, data, PMSCustomerServices.getAuthHeader())
    }

    static updateCustomerByIdByPharmacyId(id, pharmacyId, data) {
        return axios.put(`${URL.PMS_UPDATE_CUSTOMER_BY_ID_PHARMACY_ID}/${id}/${pharmacyId}`, data, PMSCustomerServices.getAuthHeader())
    }

    static updateCustomerDueDateById(id, pharmacyId, data) {
        return axios.patch(`${URL.PMS_UPDATE_CUSTOMER_DUE_DATE_BY_ID}/${id}/${pharmacyId}`, null, {
            ...PMSCustomerServices.getAuthHeader(),
            params: data
        })
    }

    static deleteCustomerById(id) {
        return axios.delete(`${URL.PMS_DELETE_CUSTOMER_BY_ID}/${id}`, PMSCustomerServices.getAuthHeader())
    }

    static getCustomerLedger(customerId, params) {
        // TODO: Uncomment when API is ready
        // return axios.get(`${URL.PMS_GET_CUSTOMER_LEDGER}/${customerId}`, {
        //     ...PMSCustomerServices.getAuthHeader(),
        //     params
        // });

        return Promise.resolve({
            data: {
                content: [
                    {id: 1, date: "2025-08-03T16:35:00", refId: "84141324", type: "Opening Balance", description: "-", debit: 0, credit: 0, balance: 0},
                    {id: 2, date: "2025-08-03T16:35:00", refId: "84141324", type: "Sale", description: "Medicine sale", debit: 1200, credit: 0, balance: 1200},
                    {id: 3, date: "2025-08-03T16:35:00", refId: "84141324", type: "Payment", description: "Cash received", debit: 0, credit: 500, balance: 700},
                    {id: 4, date: "2025-08-03T16:35:00", refId: "84141324", type: "Sale", description: "Medicine sale", debit: 800, credit: 0, balance: 1500},
                ],
                totalElements: 4,
                closingBalance: 1500,
            }
        });
    }

    static downloadCustomerLedger(customerId, params) {
        // TODO: Uncomment when API is ready
        // return axios({
        //     url: `${URL.PMS_DOWNLOAD_CUSTOMER_LEDGER}/${customerId}`,
        //     method: "GET",
        //     responseType: "blob",
        //     params,
        //     ...PMSCustomerServices.getAuthHeaderForFileDownload(),
        // });
        return Promise.resolve(null);
    }

    static getAuthHeaderForFileDownload() {
        const accessToken = localStorage.getItem("oushodsheba_access_token");
        return {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                "Response-Type": "blob",
            },
        };
    }

    static getAuthHeader() {
        const accessToken = localStorage.getItem("oushodsheba_access_token");
        return {
            headers: {
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "application/json",
            },
        };
    }

}
